import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./OverallStandings.css";
import { motion } from "framer-motion";
import { Grid } from "react-loader-spinner";
import { get } from "../../util";
import moment from "moment-timezone";

const Standings = ({ user }) => {
  const navigate = useNavigate();

  const [scoreboard, setScoreboard] = useState([]);
  const [podium, setPodium] = useState([]);

  useEffect(() => {
    if (!user) {
      return navigate("/");
    }

    get("/api/getscoreboard").then((res) => {
      setScoreboard(res);
    });

    get("/api/getpodium").then((res) => {
      setPodium(res);
    });
  }, [user, navigate]);

  const [gold, silver, bronze] = podium;

  const now = moment();
  const date = now.format("MM/DD/YYYY");
  const time = now.format("h:mm A");

  const score_table = scoreboard.length ? (
    <>
      <div className="Standings-header">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { scale: 0.8, opacity: 0 },
            visible: {
              scale: 1,
              opacity: 1,
              transition: { delay: 0.08, duration: 0.1 },
            },
          }}
        >
          <header className="Standings-headerText">Standings</header>
        </motion.div>
        <motion.div
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { scale: 0.8, opacity: 0 },
            visible: {
              scale: 1,
              opacity: 1,
              transition: { delay: 0.2, durant: 0.1 },
            },
          }}
        >
          <h3 className="Standings-headersubText">See who's on top.</h3>
        </motion.div>
      </div>

      <h1 className="podiumheadertext">Yesterday's Podium</h1>
      <div className="Podium">
        <div className="medalWinnersContainer">
          {bronze && <div className="bronzeMedalWinner">{bronze.name}</div>}
          {gold && <div className="goldMedalWinner">{gold.name}</div>}
          {silver && <div className="silverMedalWinner">{silver.name}</div>}
        </div>
      </div>

      <h1 className="overallstandingstext"> Overall Standings</h1>

      <h1 className="updatedText">
        (Updated as of {date} @ {time})
      </h1>
      <div className="table-container">
        <table className="styled-table">
          <thead>
            <tr>
              <th className="tableheadertext">Rank</th>
              <th className="tableheadertext">Player Name</th>
              <th className="tableheadertext">Total Points</th>
              <th className="tableheadertext">Yesterday Points</th>
            </tr>
          </thead>
          <tbody>
            {scoreboard.map((entry, i) => (
              <tr>
                {entry.name === user.name ? (
                  <td className="extra-bold your-row">{i + 1}</td>
                ) : (
                  <td className="extra-bold">{i + 1}</td>
                )}
                <td className={entry._id === user._id ? "your-row" : ""}>
                  <div
                    className="Name-link"
                    onClick={() => {
                      navigate(`/profile/${entry._id}`);
                    }}
                  >
                    {entry.name}
                  </div>
                </td>
                {entry.name === user.name ? (
                  <td className="your-row">{entry.totalScore}</td>
                ) : (
                  <td>{entry.totalScore}</td>
                )}
                {entry.name === user.name ? (
                  <td className="your-row">+{entry.yesterdayScore}</td>
                ) : (
                  <td>+{entry.yesterdayScore}</td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  ) : (
    <div className="center-screen">
      <Grid color="black" height={50} width={50} />
    </div>
  );

  return <div className="bg">{score_table}</div>;
};

export default Standings;
